const axios = require('axios');
module.exports.init = me => {
  me.sendLog = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/logs/send`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response.message);
    });
  };
  me.sendBlogLogs = function (action) {
    let sub_action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'null';
    let main_value = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    let info = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '{}';
    me.sendLog({
      action,
      sub_action,
      main_value,
      context,
      info
    }, data => {
      console.log(data);
    }, error => {
      console.log(error);
    });
  };
};